import { Injectable } from '@angular/core';
import { CompanySettings } from 'src/models';

/**
 * Carries upsell-specific company setting changes through the billing upgrade dialog
 * so they can be persisted when the plan change completes.
 */
@Injectable({ providedIn: 'root' })
export class UpsellUpgradeContextService {
  private pendingSettingChanges: Partial<CompanySettings> | null = null;

  setPendingSettingChanges(changes: Partial<CompanySettings> | null): void {
    this.pendingSettingChanges = changes;
  }

  consumePendingSettingChanges(): Partial<CompanySettings> | null {
    const changes = this.pendingSettingChanges;
    this.pendingSettingChanges = null;
    return changes;
  }
}
